import { render, staticRenderFns } from "./AnnuityTargetCustom.vue?vue&type=template&id=7815a190"
import script from "./AnnuityTargetCustom.vue?vue&type=script&lang=js"
export * from "./AnnuityTargetCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports